import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67bde4b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bell",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "unread-number" }
const _hoisted_4 = {
  key: 0,
  class: "notification-list"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleNotifications()), ["prevent"])),
      class: "notifications-btn"
    }, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.newMessages), 1)
    ]),
    _createVNode(_Transition, { name: "fade-in" }, {
      default: _withCtx(() => [
        (_ctx.notifications)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (
            _ctx.notificationsList === undefined ||
            _ctx.notificationsList === null ||
            _ctx.notificationsList.length === 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " I would like to inform you that there are no notifications at this time. "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationsList, (notification, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["notification", notification.message_read === 0 ? 'unread' : '']),
                  onClick: ($event: any) => (_ctx.markAsRead(notification.id_read))
                }, [
                  (notification.url !== null)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: notification.url,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(notification.message), 9, _hoisted_7))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(notification.message), 1))
                ], 10, _hoisted_6))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}